import { __assign } from "tslib";
import { VIDEO_TYPE, AUDIO_TYPE, FILE_UPLOAD_TYPE, } from 'wix-rich-content-common';
import { resolveFileUrl } from '@wix/ricos-media';
export var getVideoUrl = function (src) {
    return "https://video.wixstatic.com/".concat(src.pathname);
};
export var getAudioUrl = function (src) { return "https://static.wixstatic.com/".concat(src.id); };
export default function urlResolutionStrategy(hasPlugin, instance, metaSiteId, _experiments // eslint-disable-line
) {
    var _a, _b, _c;
    if (!metaSiteId)
        return {};
    return {
        config: __assign(__assign(__assign({}, (hasPlugin(VIDEO_TYPE) && (_a = {},
            _a[VIDEO_TYPE] = {
                getVideoUrl: getVideoUrl,
            },
            _a))), (hasPlugin(AUDIO_TYPE) && (_b = {},
            _b[AUDIO_TYPE] = {
                getAudioUrl: getAudioUrl,
            },
            _b))), (hasPlugin(FILE_UPLOAD_TYPE) &&
            metaSiteId && (_c = {},
            _c[FILE_UPLOAD_TYPE] = {
                resolveFileUrl: resolveFileUrl(metaSiteId, instance),
            },
            _c))),
    };
}
//# sourceMappingURL=urlResolutionStrategy.js.map